import PullToRefresh from "react-simple-pull-to-refresh"

import { LoadingSpinner, SwipeToClose } from "@/components/shared"
import { GoBack } from "@/components/shared/layout"
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet"
import { AffiliateProductDetails } from "@/features/jobs/affiliates/components/affiliate-product"
import ScreenLayout from "@/layouts/screen"
import { useAffiliateDetails } from "@/modules/helpers/hooks"
import { useShowAffiliate } from "@/modules/helpers/hooks/shared"
import { cn } from "@/modules/helpers/hooks/shared/utils"
import { sendHaptic } from "@/modules/helpers/utils"

const AffiliateDetailsSheet = () => {
  const { id, setId } = useShowAffiliate()
  const { data, refetch, isLoading } = useAffiliateDetails(id, { enabled: !!id })

  const affiliateData = data?.data?.data

  const handleRefresh = async () => {
    await refetch()
  }

  const handleClose = () => {
    sendHaptic()
    setId("")
  }

  return (
    <Sheet open={!!id} modal>
      <SheetContent className="w-full !bg-transparent border-none" side="right" hiddenClose>
        <SheetTitle className="sr-only">Chi tiết tiếp thị liên kết</SheetTitle>
        <SwipeToClose
          isOpen={!!id}
          onClose={handleClose}
          className="h-full relative z-10 "
          threshold={120}
          velocityThreshold={0.8}
          minStartX={120}
        >
          {({ onClose }) => (
            <ScreenLayout transition="none">
              <div
                className={cn(
                  "flex flex-col h-screen absolute top-0 z-50 w-full max-h-[100dvh] items-center justify-center bg-white text-black transition-all duration-300",
                  {
                    "opacity-0 z-0 ": !isLoading
                  }
                )}
              >
                <LoadingSpinner className="w-32 h-32" />
              </div>
              <div
                className={cn(
                  "flex flex-col relative z-10 h-full transition-all duration-300 bg-white",
                  {
                    "opacity-0": isLoading || !affiliateData?.id
                  }
                )}
              >
                <div className="bg-white sticky top-0 z-20">
                  <GoBack onClick={onClose} />
                </div>
                {/* Content */}
                <PullToRefresh
                  onRefresh={handleRefresh}
                  pullingContent=""
                  refreshingContent={<LoadingSpinner className="w-20 h-20" />}
                  maxPullDownDistance={80}
                >
                  <div className="flex-1 flex flex-col pt-4">
                    <AffiliateProductDetails
                      id={id}
                      layoutBanner="after"
                      isShowAction={true}
                      data={affiliateData}
                      preload={true}
                    />
                  </div>
                </PullToRefresh>
              </div>
            </ScreenLayout>
          )}
        </SwipeToClose>
      </SheetContent>
    </Sheet>
  )
}

export { AffiliateDetailsSheet }
